import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/css/Awards.css";

import award1 from "../assets/img/awards/isbm-university-best-upcoming-private-university-award-2017.png";
import award2 from "../assets/img/awards/isbm-university-digital-initiatives-award-2019.webp";
import award3 from "../assets/img/awards/isbm-university-assocham-edushine-excellence-award-2019.png";
import award4 from "../assets/img/awards/isbm-university-best-education-system-university-india-award-2019.png";
import award5 from "../assets/img/awards/isbm-university-higher-education-excellence-certificate-2019.webp";
import award6 from "../assets/img/awards/isbm-university-excellence-it-education-west-india-award-2019.png";
import award7 from "../assets/img/awards/isbm-university-all-india-inter-university-woodball-winner-2023.png";
import award8 from "../assets/img/awards/isbm-university-best-emerging-private-university-chhattisgarh-2017.webp";
import award9 from "../assets/img/awards/isbm-university-best-emerging-university-award-2011.png";
import award10 from "../assets/img/awards/isbm-university-best-university-central-india-placement-2023.png";
import award11 from "../assets/img/awards/isbm-university-world-education-summit-xcellence-award-2019.png";
import award12 from "../assets/img/awards/isbm-university-best-private-university-chhattisgarh-2022.png";
import award13 from "../assets/img/awards/isbm-university-best-private-university-central-india-placement-2023.png";
import award14 from "../assets/img/awards/anand-mahalwar-outstanding-academic-excellence-award-2023.webp";
import award15 from "../assets/img/awards/anand-mahalwar-education-excellence-award-2024.webp";
import award16 from "../assets/img/awards/isbm-university-naya-bharat-utsav-participation-2024.png";
import award17 from "../assets/img/awards/isbm-university-most-innovative-university-award-2018.png";
import award18 from "../assets/img/awards/isbm-university-best-pharmaceutical-studies-award-2022.png";
import award19 from "../assets/img/awards/isbm-university-best-private-university-india-award-2024.png";
import award20 from "../assets/img/awards/isbm-university-education-excellence-award-2024.png";
import award21 from "../assets/img/awards/isbm-university-leading-private-university-central-india-award-2026.png";

const awards = [
  {
    number: "21",
    year: "2026",
    category: "University Excellence Award",
    title: "Leading Private University of the Year (Central India)",
    organisation: "WBR Corp",
    description:
      "ISBM University was recognised as the Leading Private University of the Year (Central India) at the India @2047 Leadership, Innovation & Global Power Summit & Awards 2026. The Certificate of Excellence was presented by WBR Corp on 20th August 2026 at IIT Delhi.",
    image: award21
  },
  {
    number: "20",
    year: "2024",
    category: "Education Excellence Award",
    title: "Education Excellence Award 2024",
    organisation: "LEO1",
    description:
      "ISBM University, Chhattisgarh was recognised with the Education Excellence Award 2024, acknowledging the university's contribution and commitment to excellence in higher education.",
    image: award20
  },
  {
    number: "19",
    year: "2024",
    category: "University Excellence Award",
    title: "Best Private University in India",
    organisation: "Topnotch Foundation",
    description:
      "ISBM University was recognised as the Best Private University in India at the Dr. A.P.J. Abdul Kalam Inspiration Awards 2024, presented by Topnotch Foundation on 29th June 2024 at Bharat Mandapam, New Delhi.",
    image: award19
  },
  {
    number: "16",
    year: "2024",
    category: "Participation Recognition",
    title: "Naya Bharat Utsav 2024 – Vikas Pradarshini Participation",
    organisation: "Naya Bharat Utsav",
    description:
      "ISBM University received recognition for its participation in the Vikas Pradarshini organised as part of Naya Bharat Utsav 2024.",
    image: award16
  },
  {
    number: "15",
    year: "2024",
    category: "Education Excellence Award",
    title: "Education Excellence Award 2024",
    organisation: "COER University, Roorkee",
    description:
      "Prof. (Dr.) Anand Mahalwar received the Education Excellence Award 2024 at COER University, Roorkee on 10th February 2024, recognising his achievements, contributions to education and participation as a Power Speaker at Bharat Gyan Samagam 2024.",
    image: award15
  },
  {
    number: "14",
    year: "2023",
    category: "Academic Excellence Award",
    title: "Outstanding Academic Excellence Award",
    organisation: "Apollo College of Pharmacy, Durg",
    description:
      "Prof. Anand Mahalwar received the Outstanding Academic Excellence Award from Apollo College of Pharmacy, Durg in recognition of his exceptional dedication, contribution to teaching and commitment to academic excellence.",
    image: award14
  },
  {
    number: "13",
    year: "2023",
    category: "Placement Excellence Award",
    title: "Best Private University in Central India for Placement",
    organisation: "Centre for Education Growth and Research (CEGR)",
    description:
      "ISBM University was recognised as the Best Private University in Central India for Placement 2023 for its outstanding contribution to education, skill development and research at the 20th Rashtriya Shiksha Gaurav Puraskar Ceremony, held on 18th April 2023 in New Delhi.",
    image: award13
  },
  {
    number: "10",
    year: "2023",
    category: "Placement Excellence Award",
    title: "Best University in Central India for Placement",
    organisation: "Centre for Education Growth and Research (CEGR)",
    description:
      "ISBM University, Raipur was recognised as the Best University in Central India for Placement 2023 for its outstanding contribution to education, skill development and research at the 21st Rashtriya Shiksha Gaurav Puraskar Ceremony, held on 27th September 2023 in New Delhi.",
    image: award10
  },
  {
    number: "07",
    year: "2023",
    category: "Sports Achievement",
    title: "Winner – Fairway (Men) Woodball Tournament",
    organisation: "All India Inter University Woodball Tournament",
    description:
      "ISBM University achieved the Winner title in the Fairway (Men) category at the All India Inter University Woodball Tournament, held from 17th to 27th February 2023.",
    image: award7
  },
  {
    number: "18",
    year: "2022",
    category: "Pharmaceutical Education Excellence",
    title: "Best University for Pharmaceutical Studies",
    organisation: "Indo-UK Global Business & Corporate Awards",
    description:
      "ISBM University received the Certificate of Excellence for Best University for Pharmaceutical Studies at the Indo-UK Global Business & Corporate Awards 2022, held on 4th November 2022 at the House of Lords in London, United Kingdom.",
    image: award18
  },
  {
    number: "12",
    year: "2022",
    category: "University Excellence Award",
    title: "Best Private University in Chhattisgarh",
    organisation: "Centre for Education Growth and Research (CEGR)",
    description:
      "ISBM University was recognised as the Best Private University in Chhattisgarh 2022 by the Centre for Education Growth and Research for its outstanding contribution to education, skill development and research at the 19th Rashtriya Shiksha Gaurav Puraskar Ceremony, held on 22nd December 2022 in Bengaluru.",
    image: award12
  },
  {
    number: "11",
    year: "2019",
    category: "Education Excellence Award",
    title: "World Education Summit & Xcellence Awards",
    organisation: "ASSOCHAM India",
    description:
      "ISBM University was honoured at the World Education Summit & Xcellence Awards 2019, held on 19th November 2019 in New Delhi, recognising excellence and contribution in the field of higher education.",
    image: award11
  },
  {
    number: "06",
    year: "2019",
    category: "IT Education Excellence",
    title: "Excellence in IT Education in West India",
    organisation: "ET NOW",
    description:
      "ISBM University was recognised for Excellence in IT Education in West India at the India Leadership Awards 2019, celebrating the university's contribution to technology and IT education.",
    image: award6
  },
  {
    number: "05",
    year: "2019",
    category: "Higher Education Excellence",
    title: "Certificate of Excellence in Higher Education",
    organisation: "Elets Technomedia",
    description:
      "ISBM University, Chhattisgarh received a Certificate of Excellence for its exemplary contribution to the field of higher education at the 11th Higher Education & Human Resource Conclave, held on 4th May 2019 in Pune, Maharashtra.",
    image: award5
  },
  {
    number: "04",
    year: "2019",
    category: "Education System Excellence",
    title: "Best Education System University in India",
    organisation: "ASSOCHAM India",
    description:
      "ISBM University was recognised as the Best Education System University in India at the World Education Summit & Awards 2019, held on 19th November 2019 at Le Méridien, New Delhi.",
    image: award4
  },
  {
    number: "03",
    year: "2019",
    category: "Education Excellence Award",
    title: "EduShine Excellence Award",
    organisation: "ASSOCHAM India",
    description:
      "ISBM University was honoured at the 12th ASSOCHAM National Education Summit under the EduShine Excellence Awards 2019, recognising its contribution and initiatives in higher education.",
    image: award3
  },
  {
    number: "02",
    year: "2019",
    category: "Digital Initiatives in Higher Education",
    title: "Emerging University Promoting Government Digital Initiatives",
    organisation: "ASSOCHAM India",
    description:
      "ISBM University, Chhattisgarh was recognised as an Emerging University Promoting Government Digital Initiatives at the 12th ASSOCHAM National Education Summit and EduShine Excellence Awards 2019, held on 21st February 2019 in New Delhi.",
    image: award2
  },
  {
    number: "17",
    year: "2018",
    category: "Innovation in Education Award",
    title: "Most Innovative University",
    organisation: "News18 Madhya Pradesh Chhattisgarh",
    description:
      "ISBM University was recognised as the Most Innovative University at the Sushiksha Chhattisgarh awards organised by News18 Madhya Pradesh Chhattisgarh on 20th June 2018 in Raipur.",
    image: award17
  },
  {
    number: "08",
    year: "2017",
    category: "Emerging University Award",
    title: "Best Emerging Private University in Chhattisgarh",
    organisation: "Sanibal News",
    description:
      "ISBM University was recognised as the Best Emerging Private University in Chhattisgarh at the Udaan Gram Chhattisgarh 2017 awards, acknowledging the university's growth and contribution to higher education.",
    image: award8
  },
  {
    number: "01",
    year: "2017",
    category: "Education Excellence Award",
    title: "Best Upcoming Private University",
    organisation: "ASSOCHAM India",
    description:
      "ISBM University, Chhattisgarh was recognised as the Best Upcoming Private University at the ASSOCHAM National Education Excellence Awards 2017. The award was presented by Shri Prakash Javadekar, Hon'ble Union Minister of HRD, on 23rd February 2017.",
    image: award1
  },
  {
    number: "09",
    year: "2011",
    category: "Emerging University Award",
    title: "Best Emerging University",
    organisation: "Better India Education Awards",
    description:
      "ISBM University received the Best Emerging University recognition at the Better India Education Awards 2011, held on 25th June 2011 in New Delhi, recognising its growing contribution to education.",
    image: award9
  }
];

function Awards() {
  const mainSliderRef = useRef(null);
  const browserSliderRef = useRef(null);
  const [activeAward, setActiveAward] = useState(0);

  const mainSettings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 700,
    fade: true,
    cssEase: "cubic-bezier(.22,.61,.36,1)",
    autoplay: true,
    autoplaySpeed: 7000,
    pauseOnHover: true,
    pauseOnFocus: true,
    swipe: true,
    adaptiveHeight: true,
    beforeChange: (_, next) => setActiveAward(next),
  };

  const browserSettings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: false,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const getVisibleSlides = () => {
      if (window.innerWidth <= 600) return 1;
      if (window.innerWidth <= 900) return 2;
      if (window.innerWidth <= 1200) return 3;
      return 4;
    };

    const visibleSlides = getVisibleSlides();

    const safePosition = Math.min(
      activeAward,
      Math.max(0, awards.length - visibleSlides)
    );

    browserSliderRef.current?.slickGoTo(safePosition);
  }, [activeAward]);

  const openAward = (index) => {
    setActiveAward(index);
    mainSliderRef.current?.slickGoTo(index);
  };

  return (
    <section className="awards-section" aria-labelledby="awards-heading">
      <div className="awards-glow awards-glow-left" aria-hidden="true" />
      <div className="awards-glow awards-glow-right" aria-hidden="true" />

      <div className="container mx-auto">
        <header className="awards-header">
          <div className="awards-heading-wrap">
            <span className="awards-eyebrow">
              <i />
              Awards &amp; Recognition
            </span>
            <h2 id="awards-heading">
              Celebrating the
              <em> Impact Of Excellence</em>
            </h2>
          </div>

          <div className="awards-introduction">
            <p>
              Our recognitions reflect an enduring commitment to academic
              excellence, innovation and creating meaningful opportunities for
              every learner.
            </p>
            <div className="awards-total">
              <strong>{String(awards.length).padStart(2, "0")}</strong>
              <span>
                Distinguished
                <br />
                recognitions
              </span>
            </div>
          </div>
        </header>

        <div className="award-main-slider">
          <Slider ref={mainSliderRef} {...mainSettings}>
            {awards.map((award, index) => (
              <div key={`${award.title}-${index}`}>
                <div
                  className={`award-showcase award-theme-${award.theme}`}
                  aria-hidden={activeAward !== index}
                >
                  <div className="award-visual">
                    <span className="award-watermark" aria-hidden="true">
                      {award.year}
                    </span>
                    <div className="award-image-halo" aria-hidden="true" />
                    <div className="award-image-frame">
                      <img
                        src={award.image}
                        alt={`${award.title} – ${award.organisation}`}
                      />
                    </div>
                    <div className="award-verified">
                      <span>✓</span>
                      Official Recognition
                    </div>
                  </div>

                  <article className="award-details">
                    {/* <div className="award-count">
                      <span>{String(index + 1).padStart(2, "0")}</span>
                      <i />
                      <small>{String(awards.length).padStart(2, "0")}</small>
                    </div> */}
                    <span className="award-category">{award.category}</span>
                    <h3>{award.title}</h3>
                    <p className="award-organisation">{award.organisation}</p>
                    <p className="award-description">{award.description}</p>

                    <div className="award-meta">
                      <div>
                        <small>Recognition</small>
                        <strong>{award.year}</strong>
                      </div>
                      <div>
                        <small>Presented to</small>
                        <strong>ISBM University</strong>
                      </div>
                    </div>

                    <div className="award-controls">
                      <button
                        type="button"
                        onClick={() => mainSliderRef.current?.slickPrev()}
                        aria-label="Previous award"
                      >
                        ←
                      </button>
                      <button
                        type="button"
                        onClick={() => mainSliderRef.current?.slickNext()}
                        aria-label="Next award"
                      >
                        →
                      </button>
                      <div className="award-progress" aria-hidden="true">
                        <span
                          style={{
                            width: `${((index + 1) / awards.length) * 100}%`,
                          }}
                        />
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <div className="awards-browser">
          <div className="awards-browser-header">
            <div>
              <span>Explore all recognitions</span>
              <small>Newest awards are displayed first</small>
            </div>
            <div className="awards-browser-controls">
              <button
                type="button"
                onClick={() => browserSliderRef.current?.slickPrev()}
                aria-label="Previous award thumbnails"
              >
                ←
              </button>
              <button
                type="button"
                onClick={() => browserSliderRef.current?.slickNext()}
                aria-label="Next award thumbnails"
              >
                →
              </button>
            </div>
          </div>

          <Slider
            ref={browserSliderRef}
            className="awards-slick-browser"
            {...browserSettings}
          >
            {awards.map((award, index) => (
              <div className="award-browser-slide" key={`${award.title}-nav`}>
                <button
                  type="button"
                  aria-label={`Show ${award.title}`}
                  aria-current={activeAward === index ? "true" : undefined}
                  className={`award-browser-card ${activeAward === index ? "active" : ""
                    }`}
                  onClick={() => openAward(index)}
                >
                  <span className="award-thumbnail-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="award-thumbnail-image">
                    <img src={award.image} alt="" loading="lazy" />
                  </span>
                  <span className="award-thumbnail-copy">
                    <small>{award.year}</small>
                    <strong>{award.title}</strong>
                  </span>
                  <i>↗</i>
                </button>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export { awards };
export default Awards;
